<!-- 巡检路线查看弹窗 -->
<template>
    <dialog-reset
      top="1vh"
      width="80%"
      height="78vh"
      title="巡检路线详情"
      :visible.sync="dialogVisible"
    >
      <div class="route-view-container" v-loading="loading">
        <div class="detail-content">
          <!-- 左侧详情 -->
          <div class="detail-left">
            <!-- 路线信息卡片 -->
            <el-card class="info-card">
              <div slot="header" class="card-header">
                <span class="card-title">路线信息</span>
              </div>
              <div class="info-list">
                <div class="info-item">
                  <span class="info-label">路线编号：</span>
                  <span class="info-value">{{ routeDetail.routeCode }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">路线名称：</span>
                  <span class="info-value">{{ routeDetail.routeName }}</span>
                </div>
                <div class="info-item" v-if="routeDetail.remark">
                  <span class="info-label">路线描述：</span>
                  <span class="info-value">{{ routeDetail.remark }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">状态：</span>
                  <span class="info-value">
                  <el-tag :type="routeDetail.status === 1 ? 'success' : 'info'" size="small">
                    {{ routeDetail.status === 1 ? "已启用" : "已禁用" }}
                  </el-tag>
                </span>
                </div>
                <div class="info-item">
                  <span class="info-label">预计总耗时：</span>
                  <span class="info-value">{{ routeDetail.estimatedTime }} 分钟</span>
                </div>
              </div>
            </el-card>

            <!-- 巡检点位顺序：与「添加/编辑路线」共用 route-dialog-points 样式 -->
            <el-card class="info-card info-card--points">
              <div slot="header" class="card-header">
                <span class="card-title">巡检点位顺序</span>
                <span class="card-count">共{{ pointList.length }}个点位</span>
              </div>
              <div
                class="inspection-route-points-ui route-dialog-inspection-route-points route-view-inspection-route-points"
              >
                <div class="route-point-panel route-point-panel--view">
                  <div v-if="pointList.length === 0" class="empty-points">
                    <i class="el-icon-location-outline empty-points__icon" />
                    <p class="empty-points__text">该路线暂无点位数据</p>
                  </div>
                  <div v-else class="route-point-sequence">
                    <div
                      v-for="(point, index) in pointList"
                      :key="point.pointCode || `pt-${index}`"
                      class="route-point-block"
                    >
                      <div class="route-point-block__shell">
                        <div class="route-point-headline">
                          <span class="route-point-headline__badge" aria-hidden="true">
                            <i class="el-icon-location-outline" />
                          </span>
                          <div class="route-point-headline__content">
                            <div class="route-point-headline__meta-row">
                              <span class="route-point-headline__order">{{
                                chineseOrderNumeral(index + 1)
                              }}</span>
                              <span class="route-point-headline__prefix">、巡检点位：</span>
                              <span class="route-point-headline__name-highlight">{{
                                point.pointName || "—"
                              }}</span>
                            </div>
                            <div class="route-view-point__submeta">
                              <span>点位编号 {{ point.pointCode || "—" }}</span>
                              <span class="route-view-point__submeta-sep">|</span>
                              <span>{{ point.pointLocation || "—" }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="route-point-card route-point-card--view-only">
                          <div class="route-point-card__main route-point-card__main--view-only">
                            <div class="route-point-card__items-block">
                              <div class="route-point-card__items-heading">巡检项</div>
                              <div
                                v-if="getPointInspectionItemNames(point).length"
                                :class="[
                                  'route-view-items-scroll',
                                  {
                                    'route-view-items-scroll--many':
                                      getPointInspectionItemNames(point).length > 2,
                                  },
                                ]"
                              >
                                <div class="route-point-card__item-list" role="list">
                                  <div
                                    v-for="(itemName, itemIdx) in getPointInspectionItemNames(
                                      point
                                    )"
                                    :key="itemIdx"
                                    class="route-point-card__item-row"
                                    role="listitem"
                                  >
                                    <span class="route-point-card__item-idx"
                                      >{{ itemIdx + 1 }}、</span
                                    >
                                    <span class="route-point-card__item-name">{{
                                      itemName
                                    }}</span>
                                  </div>
                                </div>
                              </div>
                              <div v-else class="route-point-card__items-empty">暂无巡检项</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-card>

            <!-- 元信息卡片 -->
            <el-card class="info-card">
              <div slot="header" class="card-header">
                <span class="card-title">其他信息</span>
              </div>
              <div class="info-grid">
                <div class="grid-item">
                  <div class="grid-content">
                    <div class="grid-label">总距离</div>
                    <div class="grid-value">{{ routeDetail.totalDistance || 0 }} 公里</div>
                  </div>
                </div>
                <div class="grid-item">
                  <div class="grid-label">创建人</div>
                  <div class="grid-value">{{ routeDetail.createName || "-" }}</div>
                </div>
                <div class="grid-item">
                  <div class="grid-label">创建时间</div>
                  <div class="grid-value">{{ routeDetail.createTime || "-" }}</div>
                </div>
                <div class="grid-item">
                  <div class="grid-label">最后修改</div>
                  <div class="grid-value">{{ routeDetail.updateName || "-" }}</div>
                </div>
                <div class="grid-item">
                  <div class="grid-label">修改时间</div>
                  <div class="grid-value">{{ routeDetail.updateTime || "-" }}</div>
                </div>
              </div>
            </el-card>
          </div>

          <!-- 右侧地图 -->
          <div class="detail-right">
            <el-card class="map-card">
              <div slot="header" class="card-header">
                <span class="card-title">路线地图</span>
              </div>
              <div class="map-container" v-loading="loading">
                <div
                  v-if="!loading && !hasValidMapPath"
                  class="map-placeholder"
                >
                  <i class="el-icon-location" />
                  <p>暂无点位坐标，无法展示地图</p>
                </div>
                <TiandiMap
                  v-if="hasValidMapPath"
                  class="route-map-el"
                  height="100%"
                  :path-points="routePathPoints"
                  :auto-fit="true"
                  :initial-markers="[]"
                  :show-toolbar="false"
                ></TiandiMap>
              </div>
            </el-card>
          </div>
        </div>
      </div>

      <div slot="dialog_footer" >
        <el-button @click="handleClose">关闭</el-button>
      </div>
    </dialog-reset>

</template>

<script>
import { getDetail } from "../api";
import TiandiMap from "@/components/tiandi-map/index.vue";

export default {
  name: "RouteViewDialog",
  components: {
    TiandiMap,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    routeId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      routeDetail: {},
      pointList: [],
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    hasValidMapPath() {
      return this.buildPathFromPoints().length > 0;
    },
    routePathPoints() {
      return this.buildPathFromPoints().map((coordinate, index) => ({
        coordinate,
        name: String(index + 1),
      }));
    },
  },
  watch: {
    visible(val) {
      if (val && this.routeId) {
        this.loadDetail();
      } else if (!val) {
        this.routeDetail = {};
        this.pointList = [];
      }
    },
    routeId(id, oldId) {
      if (this.visible && id && oldId !== undefined && id !== oldId) {
        this.loadDetail();
      }
    },
  },
  methods: {
    /** 与 RouteDialog 一致：一、二、三… */
    chineseOrderNumeral(num) {
      const n = Number(num);
      if (!n || n < 1) return "一";
      const d = "零一二三四五六七八九";
      if (n <= 10) return n === 10 ? "十" : d[n];
      if (n < 20) return "十" + (n % 10 ? d[n % 10] : "");
      if (n < 100) {
        const tens = Math.floor(n / 10);
        const ones = n % 10;
        return d[tens] + "十" + (ones ? d[ones] : "");
      }
      return String(n);
    },

    buildPathFromPoints() {
      const list = this.pointList || [];
      const path = [];
      for (let i = 0; i < list.length; i++) {
        const p = list[i];
        const lng = p.longitude != null ? p.longitude : p.lng;
        const lat = p.latitude != null ? p.latitude : p.lat;
        if (lng == null || lat == null) continue;
        const lngN = Number(lng);
        const latN = Number(lat);
        if (Number.isNaN(lngN) || Number.isNaN(latN)) continue;
        path.push([lngN, latN]);
      }
      return path;
    },

    // 加载详情
    async loadDetail() {
      this.loading = true;
      try {
        const response = await getDetail(this.routeId);
        const payload = this.extractDetailPayload(response);
        if (payload && typeof payload === "object") {
          this.routeDetail = payload;
          const ext =
            payload.inspectionRouteExtRpcDto ||
            payload.inspectionRouteExtRpcDtoList ||
            [];
          this.pointList = Array.isArray(ext)
            ? [...ext].sort(
                (a, b) => (a.sequenceNumber || 0) - (b.sequenceNumber || 0)
              )
            : [];
        }
      } catch (error) {
        console.error("加载详情失败:", error);
        this.$message.error("加载详情失败");
      } finally {
        this.loading = false;
      }
    },

    extractDetailPayload(response) {
      if (!response || !response.data) {
        return null;
      }
      const body = response.data;
      if (body.data !== undefined && body.data !== null) {
        return body.data;
      }
      if (
        body &&
        typeof body === "object" &&
        !Array.isArray(body) &&
        body.id != null
      ) {
        return body;
      }
      return null;
    },

    /** 与 RouteDialog 一致：优先 inspectionPointExtRpcDtoList，否则拆分名称 */
    getPointInspectionItemNames(point) {
      if (!point) return [];
      const list = point.inspectionPointExtRpcDtoList;
      if (Array.isArray(list) && list.length) {
        const sorted = [...list].sort((a, b) => {
          const sa = a && a.sequenceNumber != null ? Number(a.sequenceNumber) : 0;
          const sb = b && b.sequenceNumber != null ? Number(b.sequenceNumber) : 0;
          if (sa !== sb) return sa - sb;
          const ia = a && a.id != null ? Number(a.id) : 0;
          const ib = b && b.id != null ? Number(b.id) : 0;
          return ia - ib;
        });
        return sorted.map((x) => x && x.associatedObjectName).filter(Boolean);
      }
      if (point.associatedObjectName) {
        return String(point.associatedObjectName)
          .split(/[,，、]/)
          .map((s) => s.trim())
          .filter(Boolean);
      }
      return [];
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
    },

  },
};
</script>

<style lang="scss" scoped>
.route-view-container {
  .detail-content {
    display: flex;
    gap: 20px;
    align-items: flex-start;

    .detail-left {
      flex: 0 0 500px;
      width: 500px;
    }

    .detail-right {
      flex: 1;
      min-width: 0;
    }
  }

  .info-card {
    margin-bottom: 20px;

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .card-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
      }

      .card-count {
        font-size: 14px;
        color: #909399;
      }
    }

    .info-list {
      .info-item {
        display: flex;
        margin-bottom: 12px;

        .info-label {
          color: #606266;
          width: 100px;
          flex-shrink: 0;
        }

        .info-value {
          color: #303133;
          flex: 1;
        }
      }
    }

    &.info-card--points :deep(.el-card__body) {
      padding-top: 12px;
      overflow: visible;
      max-height: none;
    }

    .route-view-inspection-route-points {
      margin-top: -4px;

      .route-point-panel--view {
        padding-top: 14px;
      }

      .route-view-point__submeta {
        margin-top: 10px;
        font-size: 13px;
        font-weight: 400;
        color: #909399;
        line-height: 1.5;
      }

      .route-view-point__submeta-sep {
        margin: 0 10px;
        color: #dcdfe6;
      }

      .route-point-card--view-only .route-point-card__main--view-only {
        flex: 1;
        max-width: 100%;
      }

      /* 巡检项 ≤2 条随内容增高；>2 条时限为约两行高度并纵向滚动（避免 max-height 过大导致永远不出滚动条） */
      .route-view-items-scroll {
        overflow-x: hidden;
        padding-right: 4px;
        margin: 0;
      }

      .route-view-items-scroll--many {
        max-height: unquote("min(124px, 28vh)");
        overflow-y: auto;
        min-height: 0;

        &::-webkit-scrollbar {
          width: 6px;
        }

        &::-webkit-scrollbar-thumb {
          background: #c0c4cc;
          border-radius: 3px;

          &:hover {
            background: #a8abb2;
          }
        }
      }
    }

    .info-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;

      .grid-item {

        .grid-label {
          font-size: 12px;
          color: #909399;
          margin-bottom: 5px;
        }

        .grid-value {
          font-size: 14px;
          color: #303133;
          font-weight: 500;
        }
      }
    }
  }

  .map-container {
    position: relative;
    height: 420px;
    min-height: 400px;
    background-color: #e8ecf0;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    overflow: hidden;

    .route-map-el {
      width: 100%;
      height: 100%;
      min-height: 400px;
    }

    .map-placeholder {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;
      min-height: 400px;
      color: #909399;

      i {
        font-size: 48px;
        margin-bottom: 15px;
      }

      p {
        font-size: 14px;
      }
    }
  }
}

</style>

<style lang="scss">
@import "./route-dialog-points.scss";

/*
 * 详情：点位顺序列表恢复限高滚动（与编辑页 route-dialog-points 一致），多点位时在此处出滚动条。
 * 内层 .route-point-card 等仍保持 overflow: visible，避免「巡检项」子区域滚动被 shell 裁切。
 */
.route-dialog-inspection-route-points.route-view-inspection-route-points .route-point-sequence {
  max-height: 48vh !important;
  height: auto !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  padding-right: 4px;
}

.route-dialog-inspection-route-points.route-view-inspection-route-points .route-point-panel {
  max-height: none !important;
  overflow: visible !important;
}

.route-dialog-inspection-route-points.route-view-inspection-route-points .route-point-block__shell,
.route-dialog-inspection-route-points.route-view-inspection-route-points .route-point-card {
  overflow: visible !important;
}
</style>
